import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";

export function TableCheckbox(props) {
  const { name, value, disabled } = props;
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    if (value !== "Y" && value !== "N") {
      setFieldValue(name, "N");
    } else {
      setFieldValue(name, value);
    }
  }, [value, name, setFieldValue]);
  const checkChanged = (e) => {
    const newValue = e.target.checked ? "Y" : "N";
    setFieldValue(name, newValue);
    // const value = e.target.value;
    // setFieldValue(name, value === "N" ? "Y" : "N");
  };
  return (
    <>
      <FormControl>
        <input
          type="checkbox"
          id={name}
          name={name}
          value={value}
          onChange={checkChanged}
          // checked={value === "Y" ? true : false}
          checked={value === "Y"}
          data-testid="TableCheckbox"
          disabled={disabled}
        />
      </FormControl>
    </>
  );
}
